(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resource-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
  const card = e.target.closest('.resource-card[data-resource-type="product"]');
  if (!card) return;
  
  if (e.target.closest('button, input, label, select')) return;

  // Don't double-trigger if they clicked the link itself
  if (e.target.closest('a.resource-card__link')) return;
  
  const link = card.querySelector('a.resource-card__link');
  if (link) {
    link.click();
  }
});
  } catch(e) { console.error(e); }
})();

})();
